import Vue from 'vue'
import AscLinkCell from '@/components/atoms/AscLinkCell'

export default Vue.extend({
  components: {
    AscLinkCell,
  },

  computed: {
    getLink() {
      return this.params.data[this.params.toField] || null
    },

    getIconClass() {
      return this.params.iconClass
    },

    getLinkName() {
      return this.params.value
    },

    showIcon() {
      return this.params.showIcon
    },

    cellHighLight() {
      return this.params.cellHighLight
    },
  },

  methods: {
    handleCellClick(e) {
      e.preventDefault()
      this.params.callback(this.params.data)
    },
  },

  template: `<asc-link-cell 
  :value="getLinkName" 
  :to="getLink" 
  :icon-class="getIconClass" 
  :high-light="cellHighLight" 
  :show-icon="showIcon" 
  @OnCellClick="handleCellClick"/>`,
})
